export const defaultCountTimeIntervalForSimplifiedCondition = {
    countHours: {
        value: '0',
        required: true
    },
    countDays: {
        value: '1',
        required: true
    }
};

export const defaultCountTimeInterval = {
    countDays: {
        value: '0',
        required: true
    },
    countHours: {
        value: '0',
        required: true
    },
};


export const defaultDecompilerConditionSettings = {
    id: 1,
    conditionIsSimple: true,
    conditionName: 'New Condition Name',
    _options: [
        {
            id: 'event',
            name: 'SegmentationFilterEvent',
            isChecked: true,
        },
        {
            id: 'attribute',
            name: 'SegmentationFilterAttribute',
            isChecked: false,
        },
        {
            id: 'metric',
            name: 'SegmentationFilterMetric',
            isChecked: false,
        },
    ],
    _eventValues: {
        actionName: {
            value: '',
            required: true,
        },
        actionSubName: {
            value: '',
            required: false,
        },
        aggregationFunction: {
            name: 'AggregationFunctionNameLabel',
            value: 'COUNT',
            required: true,
        },
        aggregationColumn: {
            name: 'AggregationColumnNameLabel',
            value: '',
            required: true,
        },
        aggregationComparisonOperator: {
            name: 'ComparisonOperatorLabel',
            value: '',
            required: true,
        },
        aggregationComparisonValue: {
            name: 'ComparisonValueLabel',
            value: '',
            required: true,
        },
        ...defaultCountTimeInterval
    },
    _selectedTimeInterval: {
        _intervalType: [
            {
                id: 'lastTime',
                name: 'LastTimeIntervalLabel',
                isChecked: false,
            },
            {
                id: 'currentTime',
                name: 'CurrentTimeIntervalLabel',
                isChecked: true,
            },
        ],
        _intervalDate: {
            required: true,
            startDate: '',
            endDate: ''
        },
    },
    _attributeFilter: [],
    _clientAttributeValues: {
        attributeName: {
            name: 'ClientAttributeNameLabel',
            value: '',
            required: true,
        },
        comparisonOperator: {
            name: 'ComparisonOperatorLabel',
            value: '',
            required: true,
        },
        comparisonValue: {
            name: 'ComparisonValueLabel',
            value: [],
            required: false,
        },
    },
    _metricAttributeValues: {
        attributeName: {
            name: 'MetricAttributeNameLabel',
            value: '',
            required: true,
        },
        comparisonOperator: {
            name: 'ComparisonOperatorLabel',
            value: '',
            required: true,
        },
        comparisonValue: {
            name: 'ComparisonValueLabel',
            value: [],
            required: false,
        },
    },
};
